import { AccessorsMutatorsDecorator, Model } from '../../../helpers';

export class PaymentVoucher extends Model {


}

AccessorsMutatorsDecorator(
    'id',
    'property_id',
    'voucher_id',
    'created_at',
    'created_at_tz',
    'source_internal',
    'source',
    'guest_id',
    'amount',
    'paid_to',
    'expenses_item_id',
    'expenses_item_name',
    'payment_method_internal',
    'payment_method',
    'reservation_id',
    'reservation_ident',
    'house_account_id',
    'house_account_name',
    'purpose',
    'user_id',
    'user_name',
    'voided_at',
    'voided_by',
    'status',
    'house_account_formatted',
)(PaymentVoucher);



// WEBPACK FOOTER //
// ./src/pms-api/models/vouchers/payment-voucher.model.js